const VALUE_CREATED = 'created';
const VALUE_UPDATED = 'updated';
const VALUE_DELETED = 'deleted';
const VALUE_UNCHANGED = 'unchanged';

export const deepDiffMapper = (function () {
  return {
    map: function (obj1, obj2) {
      if (this.isFunction(obj1) || this.isFunction(obj2)) {
        throw new Error('Invalid argument. Function given, object expected.');
      }
      if (this.isValue(obj1) || this.isValue(obj2)) {
        const compare = this.compareValues(obj1, obj2);
        // if (compare === VALUE_UNCHANGED) return undefined
        return {
          type: compare,
          oldData: obj1 === undefined ? obj2 : obj1,
          newData: obj2 !== undefined ? obj2 : undefined,
        };
      }

      var diff = {};
      for (var key in obj1) {
        if (this.isFunction(obj1[key])) {
          continue;
        }

        var value2 = obj2[key];
        diff[key] = this.map(obj1[key], value2);
        if (diff[key].type === VALUE_UNCHANGED) {
          delete diff[key];
        }
      }
      for (const key in obj2) {
        if (this.isFunction(obj2[key]) || obj1[key] !== undefined) {
          continue;
        }

        diff[key] = this.map(undefined, obj2[key]);
      }

      return diff;
    },
    compareValues: function (value1, value2) {
      if (value1 === value2) {
        return VALUE_UNCHANGED;
      }
      if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
        return VALUE_UNCHANGED;
      }
      if (value1 === undefined) {
        return VALUE_CREATED;
      }
      if (value2 === undefined) {
        return VALUE_DELETED;
      }
      return VALUE_UPDATED;
    },
    isFunction: function (x) {
      return Object.prototype.toString.call(x) === '[object Function]';
    },
    isArray: function (x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    },
    isDate: function (x) {
      return Object.prototype.toString.call(x) === '[object Date]';
    },
    isObject: function (x) {
      return Object.prototype.toString.call(x) === '[object Object]';
    },
    isValue: function (x) {
      return !this.isObject(x) && !this.isArray(x);
    },
  };
})();

export const getDiffKeys = (obj1, obj2) => {
  const diff = deepDiffMapper.map(obj1, obj2);
  return Object.keys(diff).join('-');
};
